"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var ThumbsUp = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "thumbs-up" },
            react_1.default.createElement("path", { id: "Icon", d: "M6 22C6 22.5523 6.44772 23 7 23C7.55228 23 8 22.5523 8 22H6ZM8 11C8 10.4477 7.55228 10 7 10C6.44772 10 6 10.4477 6 11H8ZM10.7831 2.48812L11.6969 2.89426L10.7831 2.48812ZM21.4683 12.4562L22.4567 12.6082L21.4683 12.4562ZM7.26394 10.4061L8.17775 10.8123L7.26394 10.4061ZM20.3914 19.4562L19.403 19.3041L20.3914 19.4562ZM8 22V11H6V22H8ZM17.4262 21H4V23H17.4262V21ZM20.4799 12.3041L19.403 19.3041L21.3797 19.6082L22.4567 12.6082L20.4799 12.3041ZM15 10H18.5032V8H15V10ZM13 4.46584V8H15V4.46584H13ZM8.17775 10.8123L11.6969 2.89426L9.86924 2.08198L6.35013 10L8.17775 10.8123ZM3 20V13H1V20H3ZM4 12H6.35013V10H4V12ZM3 13C3 12.4477 3.44772 12 4 12V10C2.34315 10 1 11.3431 1 13H3ZM11.5342 1C10.8141 1 10.1617 1.42403 9.86924 2.08198L11.6969 2.89426C11.6683 2.95856 11.6045 3 11.5342 3V1ZM15 4.46584C15 2.55171 13.4483 1 11.5342 1V3C12.3437 3 13 3.65628 13 4.46584H15ZM15 8H13C13 9.10457 13.8954 10 15 10V8ZM22.4567 12.6082C22.8294 10.1852 20.9547 8 18.5032 8V10C19.7289 10 20.6663 11.0926 20.4799 12.3041L22.4567 12.6082ZM6.35013 10V12C7.1405 12 7.85675 11.5345 8.17775 10.8123L6.35013 10ZM4 21C3.44772 21 3 20.5523 3 20H1C1 21.6569 2.34315 23 4 23V21ZM17.4262 23C19.4005 23 21.0795 21.5596 21.3797 19.6082L19.403 19.3041C19.2529 20.2798 18.4134 21 17.4262 21V23Z" }))));
};
exports.default = ThumbsUp;
